$(document).ready(function () {
    const $sliders = $(".collection__slider");
    //Slick Sliders
    if ($sliders.length) {
        $sliders.each(function(){
            const $slider = $(this);
            if (!$slider.hasClass('slick-initialized')) {
                $slider.slick({
                    dots: false,
                    arrows: true,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    prevArrow: "<button class='slick-prev slick-arrow' type='button'><svg class='icon icon-arrow-left' focusable='false' viewBox='0 0 768 768'><path d='M570.75 124.5l-259.5 259.5 259.5 259.5-57 57-316.5-316.5 316.5-316.5z' /></svg><span class='sr-only'>Previous</span></button>",
                    nextArrow: "<button class='slick-next slick-arrow' type='button'><svg class='icon icon-arrow-right' focusable='false' viewBox='0 0 768 768'><path d='M570.75 124.5l-259.5 259.5 259.5 259.5-57 57-316.5-316.5 316.5-316.5z' /></svg><span class='sr-only'>Next</span></button>",
                    responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3
                            },
                        },
                        {
                            breakpoint: 980,
                            settings: {
                                slidesToShow: 2
                            },
                        },
                        {
                            breakpoint: 580,
                            settings: "unslick"
                        },
                    ],
                });
            }
        });
    }
    $(window).scroll();
});